<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      mode="vertical"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item v-for="route in routers" :key="route.name" :item="route" :base-path="route.path" :admin-unread-count="adminUnreadCount"/>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import request from "@/utils/request";

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers',
      "school_id",
    ]),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  watch: {
    school_id(newVal, oldVal) {
      setTimeout(() => {
        this.getAdminUnreadCount();
      }, 1000);
    },
    "$route": {
      handler(newValue, oldValue) {
        if (newValue.name === 'complaintList') {
          setTimeout(() => {
            this.getAdminUnreadCount();
          }, 1000);
        }
      },
      deep: true
    },
  },
  data() {
    return {
      adminUnreadCount: null,
    };
  },
  created() {
    this.getAdminUnreadCount();
  },
  methods: {
    getAdminUnreadCount() {
      request({
        url: "/api/backend/complaint/adminUnreadCount",
        method: "get",
        params: {
          school_id: this.school_id
        }
      }).then(response => {
        this.adminUnreadCount = response.data;
      });
    },
  }
}
</script>
